
import './Footer.css';
import {Link} from 'react-scroll';
function Footer(){
    

    return(
        
        <div className='footer-container'>
        <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1440 320"><path fill="#ffff" fill-opacity="1"
         d="M0,224L48,202.7C96,181,192,139,288,128C384,117,480,139,576,176C672,213,768,267,864,272C960,277,1056,235,1152,181.3C1248,128,1344,64,1392,32L1440,0L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z">
        </path></svg>
         <div className='footer__container'>
             <div className='footer__details'>
                 <img src='./Assets/aj-white.png'/>
                 <div className='details-sec'>
                     <p>Jeeva<br/><span>- web developer -</span></p>
                 </div>
             </div>
            <div className='footer__nav'>
                <p>Navigation</p>
                <ul>
                    <Link to='navbar' smooth={true} duration={1000} className='footer__li'>Home </Link>
                    <Link to='about' smooth={true} duration={1000} className='footer__li'> About </Link>
                    <Link to='portfolio' smooth={true} duration={1000} className='footer__li'>Portfolio</Link>
                    <Link to='contact' smooth={true} duration={1000} className='footer__li'>Contact</Link>
                </ul>
            </div>
            <div className='footer__media'>
                <ul>
                  <a className="icon_1" href="https://twitter.com/Jeeva0721?t=qgLOE8iWqebMwaIQtkmqbws=09" target="_blank">  <li ><i class="fab fa-twitter"></i></li> </a>
                  <a  className="icon_1" href="https://www.linkedin.com/in/jeeva-d-b13396213" target="_blank">  <li ><i class="fab fa-linkedin-in"></i></li></a>
                  <a className="icon_1"  href="https://github.com/aishugva2107" target="_blank"> <li><i class="fab fa-github"></i></li></a>
                </ul>
            </div>
         </div>
         <div className='footer_text'>
              <p>Made with 💙 and ☕ by JEEVA.</p><br/>
             
         </div>
         <div className='footer_year'> 
         <i class="fas fa-hand-holding-heart"></i>
         <p>{(new Date().getFullYear())}</p>
         </div>
        </div>
    )
}
export default Footer;